import React, {Component} from "react"
import {Link} from "react-router-dom"
import {Button, Table, Dropdown} from "semantic-ui-react"

import Sidebar from "components/Sidebar/Sidebar"
import CartMini from "components/Cart/CartMini"
import app from "app.controller"
import NavigationSidebar from "components/Navigation/NavigationSidebar"
import OrderlistSelection from "components/Orderlist/OrderlistSelection"
import Header from "components/Header/Header"
import Footer from "components/Footer/Footer"
import shop from "shop/shop"
import languageStore               from "stores/languageStore"
import "style/util.scss"
import "layout/PageLayout.scss"

class PageLayout extends Component {

  render() {
    const { currentLanguage } = languageStore
    return (
      <div className="PageLayout">
        <OrderlistSelection/>

        {/*SHOPPING CART*/}
        <Sidebar open={app.sidebar.open}
                 toggle={app.sidebar.toggle}
                 close={app.sidebar.close}>
          <CartMini/>
          {/* TO CART */}


        </Sidebar>

        <Sidebar
          left
          open={app.sidebarLeft.open}
          toggle={app.sidebarLeft.toggle}
          close={app.sidebarLeft.close}
        >
          <SidebarLeft currentLanguage={currentLanguage}/>

        </Sidebar>
        <Header/>
        <div className="page-content min-vh-100">
          {this.props.children}
        </div>
        <Footer/>
      </div>
    )
  }
}

const SidebarLeft = ({ currentLanguage }) => {
  return (
    <div className="SidebarLeft h-100 flex flex-column" >
      <div className="" style={{backgroundColor: "#ffffff"}}>
        <table style={{border: "none", boxShadow: "none"}} className="w-100 pa3">
          <colgroup>
            <col style={{width: "50px"}}/>
            <col style={{width: "50px"}}/>
            </colgroup>
          <tbody>
            <tr>
              <td className="pa3">
                        {languageStore.available.length > 1 && <section className="pr2 pt2 pb1 f4 fw6 bb bw2 b--black-30 " >
                          <div className="flex flex-row justify-start">
              <p>{translate("Sprache ändern")}:</p>
              {languageStore.available.length > 1 && <Dropdown style={{color: "black"}} text={currentLanguage.toUpperCase()}
                          pointing
                          className="pl3 link item pt1">
              <Dropdown.Menu>
              {languageStore.available.map( locale => <Dropdown.Item className="tc"  style={{minWidth: "60px"}}
                key={locale}
                onClick={() => { languageStore.setLanguage(locale); this.props.history.push("/"); }}><p className="tc">{locale.toUpperCase()}</p></Dropdown.Item> )}
              </Dropdown.Menu>
              </Dropdown>}
              </div>
            </section> }
                <p className="f3 fw6 pt3">{translate("Alle Kategorien")}</p>
              </td>
              <td className="tr pa3" style={{verticalAlign: "top"}}>
                <Button floated="right" icon="close" style={{border: "none", backgroundColor: "#f1f1f1"}} onClick={app.sidebarLeft.toggle.dispatch}/>
              </td>
            </tr>
          </tbody>
        </table>
        {/* <div className="pa3 home-logo flex flex-row">
          
          <Link to="/" onClick={app.sidebarLeft.toggle.dispatch}>
                       <img
              onLoad={(event) => {
                event.target.width /=2
              }}
              src={shop.config.logo ? shop.config.logo : undefined}
              alt="zur Startseite"/> 
          </Link>
          <div className="tr"></div>
        </div>*/}
      </div>
      <NavigationSidebar showTitle={false}/>
    </div>
  )
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/theme/lindtbShop/layout/PageLayout.js